/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Birth_Date_RequiredInputs */

const en_signup_birth_date_required = /** @type {(inputs: Signup_Birth_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your date of birth.`)
};

const pl_signup_birth_date_required = /** @type {(inputs: Signup_Birth_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj datę urodzenia.`)
};

/**
* | output |
* | --- |
* | "Please enter your date of birth." |
*
* @param {Signup_Birth_Date_RequiredInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_birth_date_required = /** @type {((inputs?: Signup_Birth_Date_RequiredInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Birth_Date_RequiredInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_birth_date_required(inputs)
	return en_signup_birth_date_required(inputs)
});